/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-key */
import React from 'react';
import './projectsPage.css';
import Header from '../components/header';
import Footer from '../components/footer';
import LegalAgent from '../components/legalAgent';

function ProductLegalAgent() {
  return (
    <div className="main">
      <Header />
      <LegalAgent />
      <Footer />
    </div>
  );
}

export default ProductLegalAgent;
